let error_value
let success_value
const checkerApi =
  'https://e1b7kpknf4.execute-api.sa-east-1.amazonaws.com/prod/api/emailcheck'

/**
 * Rule to Check if email is valid
 * @param { String } value - is a e-mail string.
 * @return { Boolean } is a valid email
 */
const verifyEmail = (input) => !input.hasAttribute('data-email-error')

const checker = (pristine, target, message) => {
  if (error_value && error_value !== target.value) {
    target.removeAttribute('data-email-error')
    if (!pristine.validate(target)) return
  }

  if (success_value !== target.value)
    target.removeAttribute('data-email-success')
  if (target.value === '' || target.hasAttribute('data-email-success')) return
  if (
    pristine.validate(target) ||
    pristine.getErrors(target).includes(message)
  ) {
    fetch(`${checkerApi}/${target.value}`, {
      mode: 'cors',
      method: 'GET',
    })
      .then((r) => r.json())
      .then((response) => {
        if (response.results.status !== 'invalid') {
          target.removeAttribute('data-email-error')
          target.setAttribute('data-email-success', true)
          success_value = target.value

          pristine.validate(target)
        } else {
          target.setAttribute('data-email-error', true)

          if (!pristine.getErrors(target).includes(message)) {
            pristine.addError(target, message)
            error_value = target.value
          }
        }
      })
  }
}

export { verifyEmail, checker }
export default verifyEmail
